import { createFileRoute, redirect } from '@tanstack/react-router'
import UserSettingsPage from '../pages/UserSettingsPage/UserSettingsPage'

export const Route = createFileRoute('/user-settings')({
  beforeLoad: ({ context }) => {
    const token = localStorage.getItem('token')
    
    if (!token) {
      throw redirect({
        to: '/',
      })
    }
  },
  component: UserSettingsPage,
})
